import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Alert, Box, Button, Link, Stack, Typography,
} from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import StudioV2AppRuntimeShell from '../../components/studio/StudioV2AppRuntimeShell';
import {
  RECRUITING_PUBLIC_DEMO_ID,
  recruitingPublicDemoDefinition,
} from '../../data/interviewFlowRecruitingDemo';

/**
 * Anonymous read-only recruiting demo — fixture data, no signup, no LLM execution.
 */
export default function StudioV2PublicDemoPage() {
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      height: '100dvh',
      maxHeight: '100dvh',
      overflow: 'hidden',
      bgcolor: 'background.default',
    }}
    >
      <Box
        sx={{
          px: 2,
          py: 1.25,
          borderBottom: 1,
          borderColor: 'divider',
          bgcolor: 'background.paper',
          flexShrink: 0,
        }}
      >
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={1}
          alignItems={{ sm: 'center' }}
          justifyContent="space-between"
        >
          <Box>
            <Typography variant="subtitle1" fontWeight={700} data-testid="hiring-demo-title">
              Hiring interview
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Read-only sample data — switch Screening / Scorecard phases and explore panels. No account required.
            </Typography>
          </Box>
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            <Button
              component={RouterLink}
              to="/signup"
              variant="contained"
              size="small"
            >
              Start free trial
            </Button>
            <Button
              component={RouterLink}
              to="/signin"
              variant="outlined"
              size="small"
            >
              Sign in
            </Button>
            <Button
              component="a"
              href="https://interviewflow.studio"
              target="_blank"
              rel="noopener noreferrer"
              size="small"
              endIcon={<OpenInNewIcon fontSize="small" />}
            >
              interviewflow.studio
            </Button>
          </Stack>
        </Stack>
      </Box>

      <Alert severity="info" sx={{ borderRadius: 0, flexShrink: 0 }}>
        Interactive demo with pre-filled screening and scorecard fixtures.
        {' '}
        <Link component={RouterLink} to="/signup" underline="hover">
          Create an account
        </Link>
        {' '}
        to run live AI screening on your rubric.
      </Alert>

      <Box sx={{
        flex: 1, minHeight: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column',
      }}
      >
        <StudioV2AppRuntimeShell
          definition={recruitingPublicDemoDefinition}
          mongoId={RECRUITING_PUBLIC_DEMO_ID}
          studioPreview
          demoReadOnly
        />
      </Box>
    </Box>
  );
}
